//------------------------------------------------------ externos
import { useState } from "react";
//------------------------------------------------------ elementos
//------------------------------------------------------ funciones
import Button from "../../buttons/Button";
import FormPersona from "../../formularios/FormPersona";

const MovimientoPersonaAccess = ({
  puesto = null,
  campoNoEditable = null,
  title = "PERSONA",
}) => {
  const [formVisible, setFormVisible] = useState(false);

  const handleOpen = () => {
    setFormVisible(true);
  };

  const handleClose = () => {
    setFormVisible(false);
  };

  return (
    <>
      <Button
        text={title.toUpperCase()}
        onClick={handleOpen}
        icono="personas"
        plus={true}
      />

      {formVisible && (
        <FormPersona
          subtitle={title}
          onGuardar={handleClose}
          onClose={handleClose}
          puesto={puesto}
          campoNoEditable={campoNoEditable}
        />
      )}
    </>
  );
};

export default MovimientoPersonaAccess;
